module.exports = __webpack_public_path__ + "78fe5012ba83d554949a7371362186dd.png";


//////////////////
// WEBPACK FOOTER
// ./~/icheck/skins/polaris/polaris@2x.png
// module id = 1317
// module chunks = 0